// ESM-Huelle fuer lib/scripts/pos/CLS_CStressTest.js (ESM-Welle 4d).
// Originalquelltext unveraendert uebernommen; nur der Export ist neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.

function CStressTest() {
	this.users = new Array(Array("10502", "1103"), Array("11708", "0510"), Array("10201", "2003"));
	this.currentUser = this.users.length - 1;

	this.waitTime = 30 * 1000;
	this.loginPause = 15 * 1000;
	this.firstBonTime = 3 * 1000;
	this.bonTime = 2 * 1000;
	this.posTime = 1 * 1000;
	this.dbTime = 1;
	this.printTime = 2000;

	this.testMode = "bon";
}

CStressTest.prototype.begin = function () {
	switch (this.testMode) {
	case "bon":
		POS.events.updateTS(POS.events);
		setTimeout(this.loginUsers, 100, this, 0);
		break;
	case "db":
		setInterval(this.readWriteDB, this.dbTime, this);
		break;
	case "print":
		setInterval(this.printSomething, this.printTime, this);
		break;
	}
}

CStressTest.prototype.printSomething = function (me) {
	var Printer = new CPrinter();

	var r = Printer.head();
	$.when(r).done(function () {
		var customerData = new Array();
		customerData.firstName = "__________________________";
		customerData.surname = "";
		customerData.address = "__________________________";
		customerData.zip = "_____";
		customerData.city = "____________________";

		Printer.addLine("A", 1, false, 0);
		var text = POS.lang.getText("LABELS", "CUSTOMER_DATA") + ": ";
		Printer.addElement(text, 20, 2, true, 0, 41);
		Printer.addLine("B", 1, false, 3);

		Printer.addLine("A", 1, false, 0);
		Printer.addElement(POS.lang.getText("LABELS", "NAME") + ":", 0, 0,
			false, 0, 10);
		Printer.addElement(customerData.firstName + " " + customerData.surname,
			11, 0, false, 11, 40);
		Printer.addLine("A", 1, false, 0);
		Printer.addElement(POS.lang.getText("LABELS", "ADDRESS") + ":", 0, 0,
			false, 0, 10);
		Printer.addElement(customerData.address, 11,
			0, false, 11, 40);
		Printer.addLine("A", 1, false, 0);
		Printer.addElement(customerData.zip + " " + customerData.city,
			11, 0, false, 11, 40);

		Printer.addLine("B", 1, false, 2);
		Printer.addLine("A", 1, false, 0);
		text = POS.lang.getText("LABELS", "SIGNATURE") + "";
		Printer.addElement(text, 20, 2, true, 0, 41);
		Printer.addLine("B", 1, false, 6);
		Printer.addLine("B", 1, false, 6);
		Printer.addDivisionLine();

		var r2 = Printer.foot();
		$.when(r2).done(function () {
			Printer.print();

			var d = new Date();

			sdump("Printed on timestamp: " + (d / 1000).toFixed(0));
		});
	});
}

CStressTest.prototype.readWriteDB = function (me) {
	/*privMan.enablePrivilege (privList);*/

	var randUser = me.users[getRandomNumber(0, me.users.length - 1)];
	var userLogin = randUser[0];
	userLogin = userLogin.replace("L", "");
	var userId = randUser[1];

	var sql = "SELECT Name FROM U Where Login = " + userLogin;
	var r = POS.SQLiteCon.execute(sql);

	var userName = null;
	$.when(r).then(function (rows) {
		if (rows.length > 0) {
			//userName = r.getColumnByName("Name");
			userName = rows[0].Name;
			sdump("Read user " + userLogin + " from table U");
		}

	});

	var d = new Date();
	sql = "INSERT INTO BON " +
		"(Closed, Start, End, POS_ID, U_ID, UName, Cancelled, Type, CUST_ID, Exported) " +
		"VALUES (-1, " + (d / 1000).toFixed(0) + ", 0, " + POS.POSId + ", " +
		userLogin + ", '" + userName + "', 0, 'TST', NULL, 0)";

	var r = POS.SQLiteCon.execute(sql);
	var id = 0;
	$.when(r).then(function () {
		var i = POS.SQLiteCon.lastInsertId();
		$.when(i).then(function (lid) {
			id = lid;
		});
	});
	sdump("Wrote line " + id + " in table BON");

	//   r.free();
}

CStressTest.prototype.loginUsers = function (me, i) {
	POS.events.updateTS(POS.events);
	POS.events.BarcodeReader.processInput(me.users[i][0], null, "screen");
	POS.sessions.openSessions[0].components.container.components.pin.field.
	input.properties.attributes.value = me.users[i][1];
	POS.sessions.openSessions[0].login(POS.sessions.openSessions[0], null, null);

	i++;

	if (i < me.users.length)
		setTimeout(me.loginUsers, me.loginPause, me, i);
	else
		setTimeout(me.createBon, me.firstBonTime, me);
}

CStressTest.prototype.createBon = function (me) {
	POS.events.updateTS(POS.events);
	POS.events.BarcodeReader.processInput(me.users[me.currentUser][0], null, "screen");

	setTimeout(me.hideMessage, 1000, me);
	setTimeout(me.addProd, me.bonTime, me, 0, getRandomNumber(1, 3));
}

CStressTest.prototype.addProd = function (me, count, max) {
	var doit = true;

	if (POS.sessions.currentSession != 0)
		var mainPOS = POS.sessions.getSessionComponent();
	else {
		setTimeout(me.createBon, me.firstBonTime, me);
		return;
	}

	var itemCount = mainPOS.components.prodSelect.items.length;
	var item = getRandomNumber(0, itemCount);

	if (typeof mainPOS.components.prodSelect.items[item] == "undefined")
		doit = false;

	if (doit) {
		var prodCount = mainPOS.components.prodSelect.items[item].length;
		var prod = getRandomNumber(0, prodCount);
	}

	if (doit && typeof mainPOS.components.prodSelect.items[item][prod] == "undefined")
		doit = false;

	if (doit && mainPOS.components.prodSelect.items[item][prod].properties.attributes.onMousedown_parameter_2 != "screen")
		doit = false;

	if (doit) {
		var prodId = mainPOS.components.prodSelect.items[item][prod].properties.
			attributes.onMousedown_parameter_1;

		var parameters = new Array(mainPOS.id, prodId, "screen");

		mainPOS.addProd(null, parameters);

		if (POS.message.sessions[mainPOS.id].active == true)
			POS.message.hide();

		count++;
	}

	if (count < max)
		setTimeout(me.addProd, me.posTime, me, count, max);
	else
		setTimeout(me.finishBon, me.posTime, me);
}

CStressTest.prototype.finishBon = function (me) {
	if (POS.sessions.currentSession != 0)
		var mainPOS = POS.sessions.getSessionComponent();
	else {
		setTimeout(me.createBon, me.firstBonTime, me);
		return;
	}

	var parameters = new Array(mainPOS.id, 1);
	mainPOS.payment(null, parameters);

	mainPOS.components.info.input.properties.attributes.value = getRandomNumber(40, 60);
	mainPOS.cmpBAR.onValueChanged(mainPOS.cmpBAR);
	parameters = new Array(mainPOS.cmpBAR.id, "normal", "");
	setTimeout(mainPOS.cmpBAR.ok, 500, null, parameters);

	//    parameters = new Array(mainPOS.BonManager.cmpBCC.id, "normal");
	//    setTimeout(mainPOS.BonManager.cmpBCC.paymentOk, 500, null, parameters);
	/*
	var debuggerService = Components.classes["@mozilla.org/js/jsd/debugger-service;1"].
	getService(Components.interfaces.jsdIDebuggerService);
	debuggerService.GC();
	 */
	var rnd = getRandomNumber(0, 100);

	if (rnd <= 60)
		me.createBon(me);
	else if (rnd > 60 && rnd <= 75)
		me.wait(me);
	else if (rnd > 75)
		me.switchUser(me);
}

CStressTest.prototype.wait = function (me) {
	setTimeout(me.createBon, me.waitTime, me);
}

CStressTest.prototype.switchUser = function (me) {
	var u = getRandomNumber(0, this.users.length - 1);
	POS.events.BarcodeReader.processInput(me.users[u][0], null, "screen");
	me.currentUser = u;

	setTimeout(me.hideMessage, 1000, me);
	setTimeout(me.createBon, me.bonTime, me);
}

CStressTest.prototype.hideMessage = function (me) {
	POS.message.hide();
}

export { CStressTest };
